export const planNames = ['monthly', 'yearly', 'day_pass'] as const;

export const BASIC_MEMBERSHIP_MONTHLY_USD = 75;
export const PREMIUM_MEMBERSHIP_MONTHLY_USD = 65;
export const DAYPASS_USD = 30;

export const PaymentPurpose = Object.freeze({
  BASIC_MEMBERSHIP_INITIAL: 'BASIC_MEMBERSHIP_INITIAL',
  ANNUAL_MEMBERSHIP_INITIAL: 'ANNUAL_MEMBERSHIP_INITIAL',
  DAY_PASS: 'DAY_PASS',
});

export const PaymentMethod = Object.freeze({
  STRIPE_AUTOPAY: 'STRIPE_AUTOPAY',
  MANUAL_CASH: 'MANUAL_CASH',
  MANUAL_CARD: 'MANUAL_CARD',
  STRIPE: 'STRIPE',
});
export const MEMBERSHIP_PLAN_OBJS = [
  {
    planName: 'Monthly',
    planDetails: 'Pay As You Go',
    planPrice: `$${BASIC_MEMBERSHIP_MONTHLY_USD}/Mo`,
    value: 'monthly',
  },
  {
    planName: 'Yearly',
    planDetails: '12 Month Agreement',
    planPrice: `$${PREMIUM_MEMBERSHIP_MONTHLY_USD}/Mo ($765/Yr)`,
    value: 'yearly',
  },
  {
    planName: 'Daypass',
    planDetails: '24 Hour Pass',
    planPrice: `$${DAYPASS_USD}/Day`,
    value: 'day_pass',
  },
] as const;
